import AppLaunchLoader from '@components/layout/screen_loaders/AppLaunchLoader'
import { Outlet, useSearchParams } from 'react-router-dom'
import { useAuthContext } from '@contexts/authContext'
import LeftNavDrawer from './LeftNavDrawer'
import styled from '@emotion/styled/macro'
import useLoading from '@hooks/useLoading'
import BottomDrawer from './BottomDrawer'
import { useLayoutEffect } from 'react'
import RightDrawer from './RightDrawer'
import BottomNav from './BottomNav'

// This background is useful to set for transitions between modals where you don't want the underlying screen to be seen
// For example, going back and forth between the nearby profile and message modal would display the map in-between animations
// without this black background being set for the animation duration.
const BlackBackground = styled.div`
  height: 100dvh;
  width: 100dvw;
`

const LayoutHOC = () => {
  const [searchParams] = useSearchParams()
  const isModalOpen = searchParams.has('screen_modal') || searchParams.has('remove_background')
  const { initialAuthentication, PENDING_INITIAL_AUTH } = useAuthContext()
  // Display when the user has yet to succeed or fail initial authentication
  // const displayLoader = (initialAuthentication === PENDING_INITIAL_AUTH)
  const isInitialAuthFinished = (initialAuthentication !== PENDING_INITIAL_AUTH)
  const { isLoading, isLoadingDelayed, setIsLoading } = useLoading(true)

  useLayoutEffect(() => {
    if (isInitialAuthFinished) {
      if (isLoadingDelayed) {
        // To prevent flickering from the launcher screen appearing/disappearing too quickly
        setTimeout(() => setIsLoading(false), 1_500)
      } else {
        setIsLoading(false)
      }
    }
  }, [initialAuthentication])

  if (isLoadingDelayed) return (
    <AppLaunchLoader />
  ); else if (!isLoading && isInitialAuthFinished) return(
    <BlackBackground style={{ opacity: isModalOpen ? 0 : 1 }}>
      <BottomDrawer />
      <LeftNavDrawer />
      <RightDrawer />
      <Outlet />
      <BottomNav />
    </BlackBackground>
  ); else return (
    <BlackBackground />
  )
}

export default LayoutHOC
